import React from "react";
import Field from "./Field";
import MultiSelectControl from "./MultiSelectControl";
import { SelectListFieldProps } from "./Types";

const MultiSelectField: React.FC<SelectListFieldProps> = ({ labelProps, controlProps, visible, disabled, options }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <MultiSelectControl {...controlProps} disabled={disabled} options={options}  />
        </Field>
    );
}
export default MultiSelectField;